"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPopupState = createPopupState;
exports.bindTrigger = bindTrigger;
exports.bindToggle = bindToggle;
exports.bindHover = bindHover;
exports.bindPopover = bindPopover;
exports.bindPopper = bindPopper;
exports.bindMenu = exports.initCoreState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var React = _interopRequireWildcard(require("react"));

/* eslint-env browser */
var eventOrAnchorElWarned = false;
var initCoreState = {
  anchorEl: null,
  hovered: false,
  _childPopupState: null
};
exports.initCoreState = initCoreState;

function createPopupState(_ref) {
  var _ref$state = _ref.state,
      anchorEl = _ref$state.anchorEl,
      hovered = _ref$state.hovered,
      _childPopupState = _ref$state._childPopupState,
      setState = _ref.setState,
      parentPopupState = _ref.parentPopupState,
      popupId = _ref.popupId,
      variant = _ref.variant;

  var toggle = function toggle(eventOrAnchorEl) {
    if (anchorEl) close();else open(eventOrAnchorEl);
  };

  var open = function open(eventOrAnchorEl) {
    if (!eventOrAnchorElWarned && !eventOrAnchorEl) {
      eventOrAnchorElWarned = true;
      console.error('eventOrAnchorEl should be defined'); // eslint-disable-line no-console
    }

    if (parentPopupState) {
      if (!parentPopupState.isOpen) return;

      parentPopupState._setChildPopupState(popupState);
    }

    if ((typeof document === "undefined" ? "undefined" : (0, _typeof2.default)(document)) === 'object' && document.activeElement) {
      document.activeElement.blur();
    }

    setState({
      anchorEl: eventOrAnchorEl && eventOrAnchorEl.currentTarget ? eventOrAnchorEl.currentTarget : eventOrAnchorEl,
      hovered: eventOrAnchorEl.type === 'mouseenter'
    });
  };

  var close = function close() {
    if (_childPopupState) _childPopupState.close();
    if (parentPopupState) parentPopupState._setChildPopupState(null);
    setState({
      anchorEl: null,
      hovered: false
    });
  };

  var setOpen = function setOpen(nextOpen, eventOrAnchorEl) {
    if (nextOpen) {
      if (!eventOrAnchorEl) {
        throw new Error('eventOrAnchorEl must be defined when opening');
      }

      open(eventOrAnchorEl);
    } else close();
  };

  var onMouseLeave = function onMouseLeave(event) {
    var relatedTarget = event.relatedTarget;

    if (hovered && !isElementInPopup(relatedTarget, popupState)) {
      close();
    }
  };

  var _setChildPopupState = function _setChildPopupState(_childPopupState) {
    return setState({
      _childPopupState: _childPopupState
    });
  };

  var popupState = {
    anchorEl: anchorEl,
    popupId: popupId,
    variant: variant,
    isOpen: anchorEl != null,
    open: open,
    close: close,
    toggle: toggle,
    setOpen: setOpen,
    onMouseLeave: onMouseLeave,
    _childPopupState: _childPopupState,
    _setChildPopupState: _setChildPopupState
  };
  return popupState;
}
/**
 * Creates props for a component that opens the popup when clicked.
 *
 * @param {object} popupState the argument passed to the child function of
 * `PopupState`
 */


function bindTrigger(_ref2) {
  var _ref3;

  var isOpen = _ref2.isOpen,
      open = _ref2.open,
      popupId = _ref2.popupId,
      variant = _ref2.variant;
  return _ref3 = {}, (0, _defineProperty2.default)(_ref3, variant === 'popover' ? 'aria-owns' : 'aria-describedby', isOpen ? popupId : null), (0, _defineProperty2.default)(_ref3, 'aria-haspopup', true), (0, _defineProperty2.default)(_ref3, "onClick", open), _ref3;
}
/**
 * Creates props for a component that toggles the popup when clicked.
 *
 * @param {object} popupState the argument passed to the child function of
 * `PopupState`
 */


function bindToggle(_ref4) {
  var _ref5;

  var isOpen = _ref4.isOpen,
      toggle = _ref4.toggle,
      popupId = _ref4.popupId,
      variant = _ref4.variant;
  return _ref5 = {}, (0, _defineProperty2.default)(_ref5, variant === 'popover' ? 'aria-owns' : 'aria-describedby', isOpen ? popupId : null), (0, _defineProperty2.default)(_ref5, 'aria-haspopup', true), (0, _defineProperty2.default)(_ref5, "onClick", toggle), _ref5;
}
/**
 * Creates props for a component that opens the popup while hovered.
 *
 * @param {object} popupState the argument passed to the child function of
 * `PopupState`
 */


function bindHover(_ref6) {
  var _ref7;

  var isOpen = _ref6.isOpen,
      open = _ref6.open,
      onMouseLeave = _ref6.onMouseLeave,
      popupId = _ref6.popupId,
      variant = _ref6.variant;
  return _ref7 = {}, (0, _defineProperty2.default)(_ref7, variant === 'popover' ? 'aria-owns' : 'aria-describedby', isOpen ? popupId : null), (0, _defineProperty2.default)(_ref7, 'aria-haspopup', true), (0, _defineProperty2.default)(_ref7, "onMouseEnter", open), (0, _defineProperty2.default)(_ref7, "onMouseLeave", onMouseLeave), _ref7;
}
/**
 * Creates props for a `Popover` component.
 *
 * @param {object} popupState the argument passed to the child function of
 * `PopupState`
 */


function bindPopover(_ref8) {
  var isOpen = _ref8.isOpen,
      anchorEl = _ref8.anchorEl,
      close = _ref8.close,
      popupId = _ref8.popupId,
      onMouseLeave = _ref8.onMouseLeave;
  return {
    id: popupId,
    anchorEl: anchorEl,
    open: isOpen,
    onClose: close,
    onMouseLeave: onMouseLeave
  };
}
/**
 * Creates props for a `Menu` component.
 *
 * @param {object} popupState the argument passed to the child function of
 * `PopupState`
 */


var bindMenu = bindPopover;
/**
 * Creates props for a `Popper` component.
 *
 * @param {object} popupState the argument passed to the child function of
 * `PopupState`
 */

exports.bindMenu = bindMenu;

function bindPopper(_ref9) {
  var isOpen = _ref9.isOpen,
      anchorEl = _ref9.anchorEl,
      popupId = _ref9.popupId;
  return {
    id: popupId,
    anchorEl: anchorEl,
    open: isOpen
  };
}

function getPopup(_ref10) {
  var popupId = _ref10.popupId;
  return popupId && typeof document !== 'undefined' ? document.getElementById(popupId) // eslint-disable-line no-undef
  : null;
}

function isElementInPopup(element, popupState) {
  var anchorEl = popupState.anchorEl,
      _childPopupState = popupState._childPopupState;
  return isAncestor(anchorEl, element) || isAncestor(getPopup(popupState), element) || _childPopupState != null && isElementInPopup(element, _childPopupState);
}

function isAncestor(parent, child) {
  if (!parent) return false;

  while (child) {
    if (child === parent) return true;
    child = child.parentElement;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-popup-state/core.js
// module id = 1236
// module chunks = 0